import { NavLink } from "react-router-dom";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

/**
 * A nav entry pinned to the bottom of the sidebar rather than sitting inside a
 * group — currently just Settings, which follows the user across every suite.
 *
 * Styling deliberately mirrors `SideBarNavItem` (expanded) and `Collapsed`
 * (icon rail) so a pinned entry is indistinguishable from an inline one.
 */
export default function PinnedNavItem({
  route,
  isCollapsed,
}: {
  route: any;
  isCollapsed: boolean;
}) {
  const Icon = route.icon;

  // Align with the grouped nav items above. Those sit at 24px from the sidebar
  // edge — `SidebarGroup`'s p-2 (8px) plus the `pl-4` on `AccordionContent`'s
  // inner wrapper. The footer only contributes its own p-2, so it needs the
  // matching pl-4 or Settings hangs 16px to the left of everything else.
  return (
    <SidebarMenu
      className={isCollapsed ? "w-full items-center" : "pl-4"}
    >
      <SidebarMenuItem
        className={isCollapsed ? "flex w-full justify-center" : "relative"}
      >
        <NavLink to={route.path} className="relative block">
          {({ isActive }) =>
            isCollapsed ? (
              <SidebarMenuButton
                tooltip={route.label}
                isActive={isActive}
                className="mx-auto flex !size-9 items-center justify-center rounded-[10px] !p-0 text-[#505e59] transition-colors hover:bg-[#218760]/[0.08] hover:text-[#156548] data-[active=true]:bg-[#218760]/[0.12] data-[active=true]:font-medium data-[active=true]:text-[#156548] data-[active=true]:shadow-[inset_0_0_0_1px_rgba(33,135,96,0.18)] [&>svg]:size-[18px]"
              >
                <Icon />
                <span className="sr-only">{route.label}</span>
              </SidebarMenuButton>
            ) : (
              <>
                {isActive && (
                  <div
                    className="absolute -left-4 top-0 bottom-0 w-[8px] rounded-tr-full rounded-br-full z-10"
                    style={{ background: "var(--color-primary-gradient)" }}
                  />
                )}
                <SidebarMenuButton
                  isActive={isActive}
                  className="justify-start transition-all duration-200 ease-linear w-full"
                >
                  <Icon />
                  <span style={{ color: "var(--color-black-8)" }}>
                    {route.label}
                  </span>
                </SidebarMenuButton>
              </>
            )
          }
        </NavLink>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
